import api from './client.js'

export const screensAPI = {
  list:       ()             => api.get('/screens'),
  create:     (data)         => api.post('/screens', data),
  update:     (id, data)     => api.patch(`/screens/${id}`, data),
  remove:     (id)           => api.delete(`/screens/${id}`),
  setRoute:   (id, route)    => api.post(`/screens/${id}/route`, { route }),
  heartbeat:  (slug)         => api.post(`/screens/heartbeat/${slug}`),
  setRotation: (id, data)    => api.post(`/screens/${id}/rotation`, data),

  listPresets:  ()           => api.get('/screens/content-presets'),
  createPreset: (data)       => api.post('/screens/content-presets', data),
  updatePreset: (id, data)   => api.patch(`/screens/content-presets/${id}`, data),
  deletePreset: (id)         => api.delete(`/screens/content-presets/${id}`),

  listBoards:      ()             => api.get('/screens/custom-boards'),
  getBoardBySlug:  (slug)         => api.get(`/screens/custom-boards/by-slug/${slug}`),
  createBoard:     (data)         => api.post('/screens/custom-boards', data),
  updateBoard:     (id, data)     => api.patch(`/screens/custom-boards/${id}`, data),
  deleteBoard:     (id)           => api.delete(`/screens/custom-boards/${id}`),

  listScenes:   ()           => api.get('/screens/scenes'),
  createScene:  (data)       => api.post('/screens/scenes', data),
  captureScene: (data)       => api.post('/screens/scenes/capture', data),
  applyScene:   (id)         => api.post(`/screens/scenes/${id}/apply`),
  updateScene:  (id, data)   => api.patch(`/screens/scenes/${id}`, data),
  deleteScene:  (id)         => api.delete(`/screens/scenes/${id}`),
}
